<div class="row">
    <div id="moduleSideNav" class="col-16">
        <cna-learning-module-accordion-sidenav
            [moduleDocumentInfo]="moduleInfo$ | async"
            [sidebar]="true"
        ></cna-learning-module-accordion-sidenav>
    </div>
</div>
